var map = {
	"./ar.json": 9291,
	"./de.json": 9837,
	"./en-US.json": 6263,
	"./es.json": 5117,
	"./fr.json": 6115,
	"./hi.json": 2686,
	"./it.json": 9399,
	"./pt.json": 5909,
	"./ru.json": 482,
	"./zh-CN.json": 1659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1267;